<template>
  <div class="banner-top-section" v-if="banners && banners.length">
    <transition name="fade">
      <v-container>
        <v-row :no-gutters="!banners.length > 1">
          <hooper-container
            class="slides-container"
            style="height: auto"
            :settings="hooperSettings"
            ref="carousel"
          >
            <hooper-slide v-for="({ link, img }, i) in banners" :key="i">
              <v-col cols="12" class="px-3 px-sm-4">
                <a
                  v-if="link"
                  :href="link"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <img
                    class="d-block"
                    width="100%"
                    :src="files + img + '?resize=1&w=1200'"
                  />
                </a>
                <img
                  v-else
                  class="d-block"
                  width="100%"
                  :src="files + img + '?resize=1&w=1200'"
                />
              </v-col>
            </hooper-slide>
          </hooper-container>
        </v-row>
      </v-container>
    </transition>
  </div>
</template>

<script>
const _config = {
  mod: "banners",
};
export default {
  props: {
    itemsToShow: {
      type: Number,
      required: true,
    },
    position: {
      type: String,
      required: true,
    },
  },
  data: () => ({
    loading: true,
    settings: {
      itemsToSlide: 1,
      playSpeed: 7000,
      hoverPause: true,
      wheelControl: false,
      mouseDrag: false,
    },
  }),
  computed: {
    hooperSettings() {
      return {
        ...this.settings,
        infiniteScroll: this.slidesAvailable ? true : false,
        itemsToShow: this.itemsToShow,
        autoPlay: this.slidesAvailable ? true : false,
        breakpoints: {
          0: {
            itemsToShow: 1,
          },
          960: {
            itemsToShow: this.itemsToShow,
          },
        },
      };
    },
    slidesAvailable() {
      const smAndDown = this.$vuetify.breakpoint.smAndDown;
      const bannersCount = this.banners.length;

      if (smAndDown) {
        return bannersCount > 1;
      } else {
        return bannersCount > 2;
      }
    },

    typeId() {
      const types = { top: 1, middle: 2, bottom: 3 };
      return types[this.position] || 1;
    },
    banners() {
      return this.$rest(_config.mod).list.filter(
        (banner) => banner.type.id === this.typeId
      );
    },
  },
};
</script>
<!-- 
<style lang="scss" scoped>
.banner-top-section {
  img {
    aspect-ratio: 1140 / 190;
    object-fit: contain;
  }
}
</style> -->
